import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-audio-next",
  templateUrl: "./med-icon-audio-next.component.html",
})
export class MedIconAudioNextComponent extends SvgMixinComponent {}
